import { CarPdfViewer } from "@app/components/PdfViewer";
import { useSearchParams } from "react-router-dom";
import { useAssetClassExtendedStat } from "../useAssetClassExtendedStat";
import { AssetClassLoadType } from "@app/features/assets/useAssetClasses";
import { CarPdfDocument } from "@app/components/PdfDocument";
import { CarPdfPage, defaultClientPageSize } from "@app/components/PdfPage";
import { useUser } from "@app/pages/settings/useUser";
import { assetClassAnalysisPages } from "@app/const/route.const";
import { MultiPeriodReturnPdfChart } from "./MultiPeriodReturnPdfChart";
import { MultiPeriodReturnPdfTable } from "./MultiPeriodReturnPdfTable";

const CHART_HEIGHT = 248;

export const PdfMultiPeriodReturnReportPage = () => {
  const [searchParams] = useSearchParams();
  const { assetClass1Id, assetClass2Id } =
    assetClassAnalysisPages.getPdfMultiPeriodReturnReportParams(searchParams);

  const data = useAssetClassExtendedStat({
    type: AssetClassLoadType.byLatestSimulationJob,
    filterByUsableInPortfolios: true,
  });

  const user = useUser();

  const ac1Label = data.multiPeriodReturnComparison.find(
    (i) => i.id === assetClass1Id,
  )?.label;

  const ac2Label = data.multiPeriodReturnComparison.find(
    (i) => i.id === assetClass2Id,
  )?.label;

  const title = `Multi-Period Return ${ac1Label} vs. ${ac2Label}`;
  const footer = "Asset Class Analysis";

  return (
    <CarPdfViewer isLoading={user.isLoading || data.isLoading}>
      <CarPdfDocument title={title} author={user.userFullName}>
        {
          <CarPdfPage
            reportTitle="Multi - Period Return"
            sectionTitle="Historical Analysis"
            footer={footer}
          >
            <MultiPeriodReturnPdfChart
              style={{ marginTop: 28 }}
              width={defaultClientPageSize.width}
              height={CHART_HEIGHT}
              data={data.multiPeriodReturnComparison}
              data1Id={assetClass1Id}
              data2Id={assetClass2Id}
              isWhiteContext
            />
            <MultiPeriodReturnPdfTable
              style={{ marginTop: 30 }}
              data={data.multiPeriodReturnComparison}
              data1Id={assetClass1Id}
              data2Id={assetClass2Id}
            />
          </CarPdfPage>
        }
      </CarPdfDocument>
    </CarPdfViewer>
  );
};
